import {HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseDaoService, User} from '@q9elements/ui-kit/common';
import {Observable} from 'rxjs';

import {UpdateNodesAction} from '../../editor-interface/components/update-tags-dialog/models/update-tags.interface';
import {MassUpdateVerifyInterface} from '../../editor-interface/models/mass-update-verify.interface';
import {BDReportParams, BDReportResponse} from '../../models/rme/big-data-reports.interface';

@Injectable({
  providedIn: 'root'
})
export class RmeNodeDaoService extends BaseDaoService {
  constructor() {
    super();
  }

  deleteMultipleNodes(refModelId: string): Observable<any> {
    const url = `${this.apiUrl}/refmodel/${refModelId}/nodes`;
    return this.http.delete(url);
  }

  searchNode(
    query: string,
    refModelId: string,
    sfType: string | undefined,
    limit: number | undefined
  ): Observable<any> {
    const url = `${this.apiUrl}/search/refmodel`;
    let params = new HttpParams().set('refmodel', refModelId).set('query', query);

    if (sfType) {
      // HttpParams is immutable, have to redeclare
      params = params.append('sfType', sfType);
    }
    if (limit) {
      params = params.append('limit', limit.toString());
    }

    return this.http.get(url, {params});
  }

  public generateBigDataReport(params: BDReportParams): Observable<BDReportResponse> {
    const url = `${this.apiUrl}/big-data-report/${params.refModelId}`;

    return this.http.post<BDReportResponse>(url, params);
  }

  public nodesBulkAction(
    refModelId: string,
    action: UpdateNodesAction,
    payload: {
      nodes: string[];
      value: string | string[];
      field?: string;
    }
  ) {
    const url = `${this.apiUrl}/refmodel/${refModelId}/nodes/bulk/${action}`;

    return this.http.put(url, payload);
  }

  public checkForDependents(
    refModelId: string,
    payload: {
      nodeIds: string[];
      cnaId: string;
      implementation: string;
    }
  ): Observable<MassUpdateVerifyInterface> {
    const url = `${this.apiUrl}/customisations/rm/${refModelId}/field-dependency/verify-mass-update`;
    return this.http.post<MassUpdateVerifyInterface>(url, payload);
  }

  public getOptimizeAssignee(refModelId: string, search?: string) {
    const url = `${this.apiUrl}/refmodel/${refModelId}/optimizeAssignees`;
    const params = new HttpParams().append('search', search || '');

    return this.http.get<User[]>(url, {params});
  }
}
